import styles from "../../css/coursedetails.module.css";

function CorelDrawOutline() {
  return (
    <>
      <p>
        <strong>This Course is also available in this program:</strong>
      </p>
      <ul className={styles.learnStruct}>
        <li>Graphics Design</li>
      </ul>
    </>
  );
}

export default CorelDrawOutline;
